// extracted by mini-css-extract-plugin
export default {"root":"XiSIn_","scrollable":"HwQd2A","sideBorders":"DkU_kN","withShadow":"q75il5","topBottomBorders":"FdMMO_","bw":"w3uphA"};